export const GOOGLE_ANALYTICS_ACCOUNT = 'G-NSEKRQF5TF';
export const SUPPORT_URL = 'https://support.bumble.com/hc';
